import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  scoresWrapper: {
    display: 'flex',
    alignItems: 'center',
    minWidth: '100px',
    maxWidth: '100px',
    '&.neutral': {
      color: theme.palette.ryderCup.neutral,
      flexDirection: 'column',
      justifyContent: 'center',
    },
    '&.winner': {
      color: theme.palette.primary.contrastText,
      flexDirection: 'column',
      justifyContent: 'center',
    },
    '&.usa': {
      color: theme.palette.ryderCup.usa,
    },
    '&.intl': {
      color: theme.palette.ryderCup.intl,
    },
    '& h4': {
      '&.conceded': {
        fontSize: '12px',
        textTransform: 'uppercase',
        fontFamily: 'Nunito Sans',
        letterSpacing: '1px',
      },
    },
    [theme.breakpoints.down('sm')]: {
      minWidth: '50px',
    },
  },
}))

export default useStyles
